var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.cloud
    ? _c(
        "div",
        {
          staticClass: "lite_popup lite_business_cloud_popup",
          on: {
            click: function($event) {
              $event.stopPropagation()
            }
          }
        },
        [
          _c(
            "div",
            {
              staticClass: "lite_popup_box lite_business_cloud_box",
              class: { lite_google_workspace_box: _vm.isGoogleWorkspace },
              attrs: {
                role: "dialog",
                "aria-modal": "true",
                "aria-label": _vm.title
              }
            },
            [
              _c("div", { staticClass: "lite_popup_title" }, [
                _c("span", [_vm._v(_vm._s(_vm.title))]),
                _vm._v(" "),
                _c("button", {
                  staticClass: "icon white-close lite_business_close",
                  attrs: {
                    type: "button",
                    disabled: !!_vm.connecting,
                    "aria-label": _vm.$t("language.common.close")
                  },
                  on: {
                    click: function($event) {
                      return _vm.$emit("close")
                    }
                  }
                })
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "lite_business_cloud_content",
                  class: {
                    lite_google_workspace_content: _vm.isGoogleWorkspace
                  }
                },
                [
                  _vm.isGoogleWorkspace
                    ? [
                        _c("div", {
                          staticClass: "lite_google_workspace_intro",
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.$t(
                                "language.popup.addCloudPopup.googleWorkspaceGuideIntro"
                              )
                            )
                          }
                        }),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "lite_google_workspace_step" },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "lite_google_workspace_step_descriptions"
                              },
                              [
                                _c("div", {
                                  staticClass:
                                    "lite_google_workspace_step_description",
                                  class: { active: _vm.guideStep === 1 },
                                  domProps: {
                                    innerHTML: _vm._s(
                                      _vm.$t(
                                        "language.popup.addCloudPopup.googleWorkspaceGuideStep1"
                                      )
                                    )
                                  }
                                }),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "lite_google_workspace_step_description",
                                    class: { active: _vm.guideStep === 2 }
                                  },
                                  [
                                    _c("div", {
                                      domProps: {
                                        innerHTML: _vm._s(
                                          _vm.$t(
                                            "language.popup.addCloudPopup.googleWorkspaceGuideStep2"
                                          )
                                        )
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "lite_google_workspace_copy_rows"
                                      },
                                      _vm._l(_vm.guideCopyItems, function(
                                        item
                                      ) {
                                        return _c(
                                          "div",
                                          {
                                            key: item.value,
                                            staticClass:
                                              "lite_google_workspace_copy_row"
                                          },
                                          [
                                            _c("span", [
                                              _vm._v(
                                                _vm._s(_vm.$t(item.label)) + ":"
                                              )
                                            ]),
                                            _vm._v(" "),
                                            _c("code", [
                                              _vm._v(_vm._s(item.value))
                                            ]),
                                            _vm._v(" "),
                                            _c(
                                              "button",
                                              {
                                                staticClass:
                                                  "lite_google_workspace_copy",
                                                class: {
                                                  copied:
                                                    _vm.copiedValue ===
                                                    item.value
                                                },
                                                attrs: {
                                                  type: "button",
                                                  "aria-label": _vm.$t(
                                                    "language.common.copy"
                                                  ),
                                                  title:
                                                    _vm.copiedValue ===
                                                    item.value
                                                      ? _vm.$t(
                                                          "language.liteApp.copySuccess"
                                                        )
                                                      : _vm.$t(
                                                          "language.common.copy"
                                                        )
                                                },
                                                on: {
                                                  click: function($event) {
                                                    return _vm.copyGuideValue(
                                                      item.value
                                                    )
                                                  }
                                                }
                                              },
                                              [
                                                _c("i", {
                                                  staticClass: "icon copy",
                                                  attrs: {
                                                    "aria-hidden": "true"
                                                  }
                                                })
                                              ]
                                            )
                                          ]
                                        )
                                      }),
                                      0
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c("div", {
                                  staticClass:
                                    "lite_google_workspace_step_description",
                                  class: { active: _vm.guideStep === 3 },
                                  domProps: {
                                    innerHTML: _vm._s(
                                      _vm.$t(
                                        "language.popup.addCloudPopup.googleWorkspaceGuideStep3"
                                      )
                                    )
                                  }
                                })
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "lite_google_workspace_visual" },
                              [
                                _c(
                                  "button",
                                  {
                                    staticClass:
                                      "lite_google_workspace_step_button previous",
                                    attrs: {
                                      type: "button",
                                      disabled: _vm.guideStep === 1,
                                      "aria-label": _vm.$t(
                                        "language.common.upStep"
                                      ),
                                      title: _vm.$t("language.common.upStep")
                                    },
                                    on: { click: _vm.previousGuideStep }
                                  },
                                  [
                                    _c("span", {
                                      attrs: { "aria-hidden": "true" }
                                    })
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "button",
                                  {
                                    staticClass: "lite_google_workspace_image",
                                    attrs: {
                                      type: "button",
                                      "aria-label": _vm.$t(
                                        "language.popup.addCloudPopup.googleWorkspaceGuideViewImage"
                                      )
                                    },
                                    on: {
                                      click: function($event) {
                                        _vm.previewImage = true
                                      }
                                    }
                                  },
                                  [
                                    _c("img", {
                                      attrs: {
                                        src: _vm.guideImage,
                                        width: "650",
                                        height: "360",
                                        alt: _vm.$t(
                                          "language.popup.addCloudPopup.googleWorkspaceGuideImageAlt",
                                          { step: _vm.guideStep }
                                        )
                                      }
                                    })
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "button",
                                  {
                                    staticClass:
                                      "lite_google_workspace_step_button next",
                                    attrs: {
                                      type: "button",
                                      disabled:
                                        _vm.guideStep === _vm.guideStepCount,
                                      "aria-label": _vm.$t(
                                        "language.common.nextStep"
                                      ),
                                      title: _vm.$t("language.common.nextStep")
                                    },
                                    on: { click: _vm.nextGuideStep }
                                  },
                                  [
                                    _c("span", {
                                      attrs: { "aria-hidden": "true" }
                                    })
                                  ]
                                )
                              ]
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "lite_google_workspace_personal",
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.$t(
                                "language.popup.addCloudPopup.googleWorkspaceGuidePersonal"
                              )
                            )
                          }
                        })
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.cloud.description
                    ? [
                        _c("div", {
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.$t(
                                "language.popup.addCloudPopup." +
                                  _vm.cloud.description
                              )
                            )
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "lite_business_cloud_note",
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.$t(
                                "language.popup.addCloudPopup.specialDropBoxBottom"
                              )
                            )
                          }
                        })
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", { staticClass: "lite_business_cloud_actions" }, [
                    _c(
                      "button",
                      {
                        attrs: { type: "button", disabled: !!_vm.connecting },
                        on: {
                          click: function($event) {
                            return _vm.$emit("select", "organization")
                          }
                        }
                      },
                      [
                        _vm.connecting === "organization"
                          ? [
                              _vm._v(
                                _vm._s(_vm.$t("language.common.connecting"))
                              ),
                              _c("span", { staticClass: "cloudDotting" })
                            ]
                          : [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "language.popup.addCloudPopup.accessOrganization"
                                  )
                                )
                              )
                            ]
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "lite_business_personal",
                        attrs: { type: "button", disabled: !!_vm.connecting },
                        on: {
                          click: function($event) {
                            return _vm.$emit("select", "personal")
                          }
                        }
                      },
                      [
                        _vm.connecting === "personal"
                          ? [
                              _vm._v(
                                _vm._s(_vm.$t("language.common.connecting"))
                              ),
                              _c("span", { staticClass: "cloudDotting" })
                            ]
                          : [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "language.popup.addCloudPopup.accessPersonalCloud"
                                  )
                                )
                              )
                            ]
                      ],
                      2
                    )
                  ])
                ],
                2
              )
            ]
          ),
          _vm._v(" "),
          _vm.previewImage
            ? _c(
                "div",
                {
                  staticClass: "lite_google_workspace_preview",
                  attrs: {
                    role: "dialog",
                    "aria-modal": "true",
                    "aria-label": _vm.$t(
                      "language.popup.addCloudPopup.googleWorkspaceGuideViewImage"
                    )
                  },
                  on: {
                    click: function($event) {
                      if ($event.target !== $event.currentTarget) {
                        return null
                      }
                      _vm.previewImage = false
                    }
                  }
                },
                [
                  _c(
                    "div",
                    { staticClass: "lite_google_workspace_preview_box" },
                    [
                      _c("img", {
                        attrs: {
                          src: _vm.guideImage,
                          alt: _vm.$t(
                            "language.popup.addCloudPopup.googleWorkspaceGuideImageAlt",
                            { step: _vm.guideStep }
                          )
                        },
                        on: {
                          click: function($event) {
                            _vm.previewImage = false
                          }
                        }
                      })
                    ]
                  )
                ]
              )
            : _vm._e()
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-696b7c47", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-696b7c47","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/popup/add_cloud_popups/lite_business_cloud_popup.vue
// module id = null
// module chunks = 